import { selectors } from 'app-webtech-core';
import { connect } from 'react-redux';
import { MetaComponent } from '../components/Meta';

const mapStateToProps = (state) => {
  const { infoBanner } = selectors.player.properties(state);
  const { appVersion } = selectors.application.properties(state);
  if (infoBanner) {
    const name = infoBanner.channel && infoBanner.channel.name;
    const description = infoBanner.channel && infoBanner.channel.summary;
    const image = infoBanner.channel && infoBanner.channel.featuredImage;
    const url = window.location.href;

    return {
      appVersion,
      description,
      image,
      url,
      title: `Watch ${name} on Pluto TV`,
    };
  }
  return { appVersion };
};

export const Meta = connect(mapStateToProps)(MetaComponent);
